__turbopack_context__.v({
  "circleButton": "Item-module-scss-module__Gfv3-G__circleButton",
  "cta": "Item-module-scss-module__Gfv3-G__cta",
  "ctaText": "Item-module-scss-module__Gfv3-G__ctaText",
  "fade-in": "Item-module-scss-module__Gfv3-G__fade-in",
  "linkListBody": "Item-module-scss-module__Gfv3-G__linkListBody",
  "linkListHeadline": "Item-module-scss-module__Gfv3-G__linkListHeadline",
  "linkListHeadlineContainer": "Item-module-scss-module__Gfv3-G__linkListHeadlineContainer",
  "linkListIcon": "Item-module-scss-module__Gfv3-G__linkListIcon",
  "linkListItem": "Item-module-scss-module__Gfv3-G__linkListItem",
  "linkListText": "Item-module-scss-module__Gfv3-G__linkListText",
  "root": "Item-module-scss-module__Gfv3-G__root",
});
